export default __webpack_public_path__ + "static/media/selfie-red.abfffef8.png";